export default __webpack_public_path__ + "static/emphasis1.1_Elena-db78b3faffd1d03350f777ecff0aa209.wav";